import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import '../../remark-element';
import './switch';

export default {
  title: '@gsmlg/form/switch',
  argTypes: {},
} as Meta;

export interface SwithProps {
  labelText?: string;
  name: string;
  checked?: boolean;
  value?: SwithProps['onValue'] | SwithProps['offValue'];
  onValue?: string;
  offValue?: string;
  readonly?: boolean;
  disabled?: boolean;
}

// prettier-ignore
const Template: Story<SwithProps> = ({
  labelText,
  name,
  checked,
  value,
  onValue,
  offValue,
  readonly,
  disabled,
}) => {
  return html`<div>
    <h3>Switch:</h3>
    <div>
      <gsmlg-switch
        label-text=${labelText}
        name=${name}
        ?checked=${checked}
        .value=${value}
        on-value=${onValue}
        off-value=${offValue}
        ?readonly=${readonly}
        ?disabled=${disabled}
      />
    </div>

    <remark-element>
      ## gsmlg-switch element
      \`\`\`html
      ${`<gsmlg-switch
        label-text="${labelText}"
        name="${name}"
        ?checked="${checked}"
        .value=${value}
        on-value=${onValue}
        off-value=${offValue}
        ?readonly=${readonly}
        ?disabled=${disabled}
      />`}
      \`\`\`

      ## Custom Colors Set css vars

      \`\`\`css

      var(--gsmlg-switch-checked-color, #476fd8); /* color when checked */
      var(--gsmlg-switch-checked-c-color, #fff); /* circle color when unchecked */
      var(--gsmlg-switch-unchecked-color, gray); /* color when checked */
      var(--gsmlg-switch-unchecked-c-color, #bbb); /* circle color when unchecked */

      \`\`\`
    </remark-element>

  </div>`;
};

export const Basic = Template.bind({});

Basic.args = {
  labelText: 'Enable Config',
  name: 'enable-config',
  checked: false,
};

export const WithValueName = Template.bind({});

WithValueName.args = {
  name: 'enable-config',
  checked: false,
  onValue: 'yes',
  offValue: 'no',
};

export const WithInitValue = Template.bind({});

WithInitValue.args = {
  name: 'enable-config',
  value: 'on',
  onValue: 'on',
  offValue: 'off',
};

export const WithDisableAndReadonly = Template.bind({});

WithDisableAndReadonly.args = {
  name: 'enable-config',
  value: 'true',
  disabled: false,
  readonly: true,
};
